import React, { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { C, LAYOUT } from "../constants/colors";

export default function AppLayout({ user, onLogout, children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{
      display: "flex",
      minHeight: "100vh",
      background: C.bg,
    }}>
      <Navbar user={user} onLogout={onLogout} onMenuClick={() => setMobileOpen(true)} />
      <Sidebar variant="permanent" />
      <Sidebar variant="temporary" open={mobileOpen} onClose={() => setMobileOpen(false)} />

      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "visible",
        }}
      >
        <Toolbar sx={{ minHeight: `${LAYOUT.navbarHeight}px !important` }} />
        <Box sx={{ flex: 1, p: { xs: 2, md: 3 }, overflow: "visible" }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
